import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { shape, string } from "prop-types";
import React, { useContext } from "react";

const ComexSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;

    const {
        originAccountLabel = props.originAccountLabel,
        ownerName = props.ownerName,
        ownerCuit = props.ownerCuit,
        amount = props.amount,
        operationType = props.operationType,
        concept = props.concept,
        contactDestination = props.contactDestination,
        foreignCurrency = props.foreignCurrency,
    } = data;

    return (
        <GridTable className="form-summary">
            <GridTable.Container columns={3} rows={5}>
                <GridTable.Data columnStart={1} rowStart={2}>
                    <CustomData
                        titleText="mep.debitAccount.label"
                        titleTextType="I18N"
                        valueText={originAccountLabel}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={2}>
                    <CustomData titleText="comex.originName.label" titleTextType="I18N" valueText={ownerName} />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={2}>
                    <CustomData titleText="mep.holder.cuit" titleTextType="I18N" valueText={ownerCuit} />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={3}>
                    <CustomData
                        titleText="mep.creditAccount.label"
                        titleTextType="I18N"
                        valueText={contactDestination?.iban}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={3}>
                    <CustomData
                        titleText="comex.recipientName.label"
                        titleTextType="I18N"
                        valueText={contactDestination?.recipientName}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={3}>
                    <CustomData
                        titleText="mep.amount.label"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={foreignCurrency} quantity={amount.amount} noCurrencyTranslation={true} />}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={4}>
                    <CustomData
                        titleText="comex.transfer.code.label"
                        titleTextType="I18N"
                        valueText={contactDestination?.number}
                        valueTextType="text"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={4}>
                    <CustomData
                        titleText="comex.comissions.concept.title"
                        titleTextType="I18N"
                        valueText={concept}
                        valueTextType="text"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={4}>
                    <CustomData
                        titleText="comex.transfer.operationType.label"
                        titleTextType="I18N"
                        valueText={`comex.transfer.${operationType}.label`}
                        valueTextType="I18N"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

ComexSummaryBody.propTypes = {
    originAccountLabel: string,
    ownerName: string,
    ownerCuit: string,
    amount: shape({
        quantity: string,
        currency: string,
    }),
    operationType: string,
    concept: string,
    contactDestination: shape({}),
};

ComexSummaryBody.defaultProps = {
    originAccountLabel: "",
    ownerName: "",
    ownerCuit: "",
    amount: {
        quantity: "",
        currency: "",
    },
    operationType: "",
    concept: "",
    contactDestination: null,
};

export default ComexSummaryBody;
